document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.sale-ticker-section');
  const sentinel = document.querySelector('.sale-ticker-sentinel');

  if (!section || !sentinel) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // Pin if we've scrolled past the sentinel
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        const header = document.querySelector('.shopify-section-group-header-group') || document.querySelector('sticky-header');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        document.documentElement.style.setProperty('--ticker-top', headerHeight + 'px');

        section.classList.add('is-pinned');

        // Prevent layout shift by adding a spacer
        if (!section.querySelector('.sale-ticker-spacer')) {
          const spacer = document.createElement('div');
          spacer.className = 'sale-ticker-spacer';
          spacer.style.height = section.offsetHeight + 'px';
          section.appendChild(spacer);
        }
      } else {
        section.classList.remove('is-pinned');
        const spacer = section.querySelector('.sale-ticker-spacer');
        if (spacer) {
          spacer.remove();
        }
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0
  });

  observer.observe(sentinel);
});
